import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-cropper',
  templateUrl: './cropper.component.html',
  styleUrls: ['./cropper.component.scss'],
})
export class CropperComponent implements OnInit {
  @Input() imageBase64: string;
  @Input() aspectRadio: number = 1;
  // When false, the seller can crop to any orientation (vertical, horizontal or square).
  @Input() maintainAspectRatio: boolean = true;
  
  public newImage: string;
  public cleanImageBase64: string;

  constructor(private modalCtrl: ModalController) {}

  ngOnInit() {
    // Clean the base64 string to remove duplicate prefixes
    this.cleanImageBase64 = this.cleanBase64String(this.imageBase64);
  }

  private cleanBase64String(base64: string): string {
    if (!base64) return '';
    
    // Remove any duplicate "data:image/" prefixes
    const dataUrlRegex = /^data:image\/[^;]+;base64,/;
    const matches = base64.match(dataUrlRegex);
    
    if (matches) {
      // If we found a prefix, remove all instances and add it back once
      const cleanBase64 = base64.replace(dataUrlRegex, '');
      return matches[0] + cleanBase64;
    }
    
    // If no prefix found, add the default JPEG prefix
    return 'data:image/jpeg;base64,' + base64;
  }

  onImageCropped(event: any) {
    if (event && event.base64) {
      this.newImage = this.cleanBase64String(event.base64);
    }
  }

  onImageLoaded(event: any) {
    if (event && event.original && event.original.base64) {
      this.newImage = this.cleanBase64String(event.original.base64);
    }
  }

  async confirm() {
    // Ensure we have a valid image before dismissing
    if (this.newImage) {
      await this.modalCtrl.dismiss({ image: this.newImage });
    } else {
      // If no new image was cropped, return the original cleaned image
      await this.modalCtrl.dismiss({ image: this.cleanImageBase64 });
    }
  }

  async cancel() {
    await this.modalCtrl.dismiss();
  }
}
